
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StepItemProps } from ".";
import { loading, create } from "store/step";
import { AppMessage } from "components";

interface ApiStepCreateInputProps extends Omit<StepItemProps, "id"> {
}

type ApiStepCreateOutputProps = OutputBaseProps<{ item: StepItemProps; }, ApiStepCreateInputProps>

export const apiStepCreate = async (data: ApiStepCreateInputProps, workflowId: number) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiStepCreateOutputProps>(`/api/workflow/${workflowId}/step/create`, data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};